// extracted by mini-css-extract-plugin
export default {"search_result":"cart_search_result__MGOut","icon_search":"cart_icon_search__IwdNi","testName":"cart_testName__z9a0o"};